/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Menu: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="menu" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M170 283.3333333333335V396.6666666666668H1190V283.3333333333335H170zM340 623.3333333333334V736.6666666666667H1020V623.3333333333334H340zM170 963.3333333333334V1076.6666666666667H1190V963.3333333333334H170z" : "M136 226.6666666666667V317.3333333333333H952V226.6666666666667H136zM272 498.6666666666666V589.3333333333333H816V498.6666666666666H272zM136 770.6666666666666V861.3333333333333H952V770.6666666666666H136z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Menu.displayName = `Blueprint5.Icon.Menu`;
export default Menu;
